/**
 * Kept apart from TapestryScene so the collages page can ask this question
 * without pulling three.js — and its ~124KB — into the initial bundle.
 */
export const isWebGLAvailable = (): boolean => {
    try {
        const canvas = document.createElement('canvas');
        return !!(
            window.WebGLRenderingContext &&
            (canvas.getContext('webgl2') || canvas.getContext('webgl'))
        );
    } catch {
        return false;
    }
};
